import { 
     UPDATE_BIN_REQUEST,
    UPDATE_BIN_SUCCESS,
    UPDATE_BIN_FAILURE,
    GET_BIN_REQUEST,
    GET_BIN_SUCCESS,
    GET_BIN_FAILURE,
    RESET_BIN_DATA
  } from './updateBin.constants';
  
  // Initial state for the entity reducer
  const initialState = {
    updateLoading: false,      // Indicates if a fetch request is in progress
    error: null,         // Holds any error message from a failed request
    updatedBinResponse:{},    // Stores the list of entities returned from API
    binData:{},
  };
  
  // Reducer function to manage entity-related state
  export const updateBinReducer = (state = initialState, action) => {
    switch (action.type) {
      case UPDATE_BIN_REQUEST:
        return {
          ...state,
          updateLoading: true,     // Start loading spinner
          error: null,       // Clear previous errors
        };
  
      
      case UPDATE_BIN_SUCCESS:
        return {
          ...state,
          updateLoading: false,              // Stop loading spinner
          updatedBinResponse: action.payload,  // Update the list (can be empty or populated)
        };
  
      
      case UPDATE_BIN_FAILURE:
        return {
          ...state,
          updateLoading: false,       // Stop loading spinner
          error: action.payload // Store error message for display
        };

         case GET_BIN_REQUEST:
        return {
          ...state,
          updateLoading: true,     // Start loading spinner
          error: null,       // Clear previous errors
        };
  
      
      case GET_BIN_SUCCESS:
        
        return {
          ...state,
          updateLoading: false,              // Stop loading spinner
          binData: action.payload,  // Update the list (can be empty or populated)
        };
  
      
      case GET_BIN_FAILURE:
        return {
          ...state,
          updateLoading: false,       // Stop loading spinner
          error: action.payload // Store error message for display
        };

      case RESET_BIN_DATA:
        return {
          ...state,
          binData: {}

        }
      default:
        return state;
    }
  };
  